import React, { ReactNode } from 'react';
import { components, GroupBase, OptionProps } from 'react-select';
import classNames from 'classnames';

import { Checkbox } from 'app/design-system/components/Checkbox';

import styles from './MultiSelectComponents.module.scss';

type Props<T, IsMulti extends boolean, Group extends GroupBase<T>> = {
  children: ReactNode;
  className?: string;
} & OptionProps<T, IsMulti, Group>;

function Option<T, IsMulti extends boolean, Group extends GroupBase<T>>({
  children,
  className,
  ...optionsProps
}: Props<T, IsMulti, Group>): JSX.Element {
  const innerProps = {
    ...optionsProps.innerProps,
    'data-test': `option-${optionsProps.innerProps.id}`,
  };
  const optionClassnames = classNames(
    styles.optionContainer,
    {
      [styles.selected]: optionsProps.isSelected,
    },
    className,
  );

  return (
    <components.Option {...optionsProps}
                       innerProps={innerProps}>

      <div className={optionClassnames}>
        <span>{children}</span>
        <Checkbox name="multiSelectCheckbox"
                  onChange={optionsProps.getValue}
                  className={styles.optionCheckbox}
                  checked={optionsProps.isSelected} />
      </div>
    </components.Option>
  );
}

export default Option;
